import React, {useMemo} from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {Card} from 'react-bootstrap';
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "./ui.helpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  // sortCaret,
} from "../../../../_metronic/_helpers";
import {Pagination} from "../../../../_metronic/_partials/controls";
import {useQNAUIContext} from "../../../contexts/QNAUIContext";

export function QNATable(props) {
  const context = useQNAUIContext();
  const {columns, qnaList, totalCount, listLoading} = props;
  const {
    queryParams,
    setQueryParams,
    onClick,
  } = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
    onClick: (_, row) => context.openQNADetailDialog(row.qnaSeq),
  }), [context]);

  const rowEvents = { onClick: onClick };

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  return (
    <Card>
      <Card.Body>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({paginationProps, paginationTableProps}) => (
            <Pagination isLoading={listLoading} paginationProps={paginationProps}>
              <BootstrapTable
                remote
                bootstrap4
                hover
                keyField="no"
                bordered={false}
                columns={columns}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden table-responsible"
                data={qnaList === null ? [] : qnaList}
                defaultSorted={uiHelpers.defaultSorted}
                noDataIndication={<NoRecordsFoundMessage entities={qnaList}/>}
                onTableChange={getHandlerTableChange(setQueryParams)}
                rowEvents={rowEvents}
                {...paginationTableProps}
              />
            </Pagination>
          )}
        </PaginationProvider>
      </Card.Body>
    </Card>
  );
}
